<template>
  <div>
    <p>{{ titulo }}</p>
    <p class="description">{{ descripcion }}</p>
    <b-table 
        :key="key"
        hover
        striped
        responsive="sm" 
        class="registro"
        :busy="tableBusy"
        :items="rentabilidadNetaItems" 
        :fields="rentabilidadNetaFields">
      <div slot="table-busy" class="text-center">
        <b-spinner class="table-spinner" label="Spinning" />
      </div>
      <template v-slot:cell(campo)="data">
        <p v-b-tooltip.hover :title="data.item.toolTip">
          {{ data.item.campo }}
        </p>
      </template>

      <template v-slot:cell(valor)="data">
        {{ data.item.valor }}
      </template>

      <template v-slot:cell(opciones)="data">
        <template v-if= "data.item.nombre=='ventas' || data.item.nombre=='inversiones'
            || data.item.nombre=='compras' || data.item.nombre=='gastos' 
            || data.item.nombre=='sueldos' || data.item.nombre=='impuestos' 
            || data.item.nombre=='gastosBancarios'
            || data.item.nombre=='premiosReembolsos' || data.item.nombre=='deudaComercial'
            || data.item.nombre=='diferenciaCambioCompras' || data.item.nombre=='diferenciaCambioVentas'">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item 
                v-if="data.item.nombre != 'premiosReembolsos' && data.item.nombre != 'gastosBancarios'"
                @click.stop="consultaMovimientos(data.item.nombre)">
              <i class="fa fa-file-excel-o"></i>Exportar Movimientos</b-dropdown-item>
            <!-- <b-dropdown-item 
                v-if="data.item.nombre == 'inversiones'"
                @click.stop="consultaInversionesBancos">
              <i class="fa fa-file-excel-o"></i>Exportar Inversiones - Bancos</b-dropdown-item> -->
            <b-dropdown-item 
                v-if="data.item.nombre == 'gastosBancarios'"
                @click.stop="consultaGastosBancarios">
              <i class="fa fa-file-excel-o"></i>Exportar Movimientos de Banco</b-dropdown-item>
            <b-dropdown-item 
                v-if="data.item.nombre == 'gastosBancarios'"
                @click.stop="consultaGastosBancariosPlanesPago">
              <i class="fa fa-file-excel-o"></i>Exportar Gastos de Planes Cancelados via Pagos</b-dropdown-item>
            <b-dropdown-item 
                v-if="data.item.nombre == 'sueldos'"
                @click.stop="consultaGastosHonorarios">
              <i class="fa fa-file-excel-o"></i>Exportar Comprobantes Honorarios</b-dropdown-item>
            <b-dropdown-item 
                v-if="data.item.nombre == 'impuestos'"
                @click.stop="consultaImpuestosBancos">
              <i class="fa fa-file-excel-o"></i>Exportar Movimientos - Bancos</b-dropdown-item>
            <b-dropdown-item 
                v-if="data.item.nombre == 'impuestos'"
                @click.stop="consultaInteresesPlanesPagosBancos">
              <i class="fa fa-file-excel-o"></i>Exportar Movimientos - Planes de Pago Bancos</b-dropdown-item>
            <b-dropdown-item 
                v-if="data.item.nombre == 'impuestos'"
                @click.stop="consultaInteresesPlanesPagosPagos">
              <i class="fa fa-file-excel-o"></i>Exportar Movimientos - Planes de Pago Cancelados via Pagos</b-dropdown-item>
            <b-dropdown-item 
                v-if="data.item.nombre == 'premiosReembolsos'"
                @click.stop="consultaPremiosReembolsos">
              <i class="fa fa-file-excel-o"></i>Exportar Transferencias</b-dropdown-item>
            <b-dropdown-item 
                v-if="data.item.nombre == 'premiosReembolsos'"
                @click.stop="consultaComprasReembolsos">
              <i class="fa fa-file-excel-o"></i>Exportar Compras x Reembolsos</b-dropdown-item>
            <b-dropdown-item 
                v-if="data.item.nombre == 'deudaComercial'"
                @click.stop="consultaVentasDeudaComercial">
              <i class="fa fa-file-excel-o"></i>Exportar Detalle de Ventas</b-dropdown-item>
            <b-dropdown-item 
                v-if="data.item.nombre == 'deudaComercial'"
                @click.stop="consultaComprasReembolsos">
              <i class="fa fa-file-excel-o"></i>Exportar Compras x Reembolsos</b-dropdown-item>
          </b-dropdown>
        </template>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      default: ''
    },
    descripcion: {
      type: String,
      default: ''
    },
    rentabilidadNetaItems: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      key: 0,
      rentabilidadNetaFields: [
        { key: 'campo' },
        { 
          key: 'valor',
          class: 'text-right' 

        },
        {
          key: 'participacion',
          label: '%.Partic.',
          class: 'text-right' 
        },
        { 
          key: 'opciones',
          class: 'text-center'  
        },
      ],
      tableBusy: false
    }
  },
  methods: {
    actualizado() {
      this.key++;
    },
    consultaMovimientos(rubro) {
      switch (rubro) {
        case 'ventas':
          this.$emit('consultaVentas');
          break;

        case 'inversiones':
          this.$emit('consultaInversionesBancarias');
          break;

        case 'compras':
          this.$emit('consultaCompras');
          break;
        
        case 'gastos':
          this.$emit('consultaGastos');
          break;

        case 'sueldos':
          this.$emit('consultaSueldos');
          break;
        
        case 'impuestos':
          this.$emit('consultaImpuestos');
          break;

        // case 'gastosBancarios':
        //   this.$emit('consultaGastosBancarios');
        //   break;

        // case 'premiosReembolsos':
        //   this.$emit('consultaPremiosReembolsos');
        //   break;

        case 'deudaComercial':
          this.$emit('consultaDeudaComercial');
          break;

        case 'diferenciaCambioCompras':
          this.$emit('consultaComprasDiferenciasCambio');
          break;

        case 'diferenciaCambioVentas':
          this.$emit('consultaVentasDiferenciasCambio');
          break;
      }
    },
    // consultaInversionesBancos() {
    //   this.$emit('consultaInversionesBancarias');
    // },
    consultaGastosBancarios() {
      this.$emit('consultaGastosBancarios');
    },
    consultaGastosBancariosPlanesPago() {
      this.$emit('consultaGastosBancariosPlanesPago');
    },
    consultaGastosHonorarios() {
      this.$emit('consultaGastosHonorarios');
    },
    consultaComprasReembolsos() {
      this.$emit('consultaComprasReembolsos');
    },
    consultaPremiosReembolsos() {
      this.$emit('consultaPremiosReembolsos');
    },
    consultaImpuestosBancos() {
      this.$emit('consultaImpuestosBancos');
    },
    consultaInteresesPlanesPagosBancos() {
      this.$emit('consultaImpuestosInteresesPlanesPagosBancos');
    },
    consultaInteresesPlanesPagosPagos() {
      this.$emit('consultaImpuestosInteresesPlanesPagosPagos');
    },
    consultaVentasDeudaComercial() {
      this.$emit('consultaVentasDeudaComercial');
    }
  }
}
</script>

<style>
  .dashboard-rentabilidad-neta {
    margin-bottom: 30px;
  }
  .dashboard-rentabilidad-neta p {
    font-size: 0.8em;
    font-weight: 700;
    margin-bottom: 0;
  }
  .dashboard-rentabilidad-neta p.description {
    font-weight: 400;
    font-style: italic;
    margin-bottom: 5px;
  }
  .dashboard-rentabilidad-neta table thead {
    display: none;
  }
  .dashboard-rentabilidad-neta table tbody tr:first-child td {
    border-top: none;
  }
  .dashboard-rentabilidad-neta table td {
    padding-top: 8px;
    padding-bottom: 8px;
  }

</style>


